export const DESIGN_WIDTH = 1920;
export const SCALE = 0.7;

export const serviceTypeIcons: Record<string, string> = {
  "product-consultation": "/images/service-icons/product-consultation.svg",
  "customized-solution": "/images/service-icons/customized-solution.svg",
  returns: "/images/service-icons/returns.svg",
  exchange: "/images/service-icons/exchange.svg",
  warranty: "/images/service-icons/warranty.svg",
  replacement: "/images/service-icons/replacement.svg",
  refund: "/images/service-icons/refund.svg",
};

export const STORAGE_KEY = "busrom_privacy_consent";
